import GuidanceRegistry from '../guidance-registry.js';
import {uploadEnrollmentsService} from '../../action-items/types/upload-enrollments-service.js'
import {guidanceUtils} from '../guidance-utils.js';
import { romeApi } from '../../framework/utils/rome-api.js';
import EnrollmentConfirmation from "../../action-items/types/EnrollmentConfirmation";

GuidanceRegistry.register({
    type: "action-item-ewf-upload-spreadsheet",
    prompt: (guidanceItem) => getPrompt(guidanceItem.planYearStartDate, guidanceItem.workflowType),
    briefDescription: 'Enrollments',
    async actions(guidanceItem) {
        return await getActions(guidanceItem);
    }, 
});

    function getPrompt(planYearStartDate, workflowType){        
        let dateString = guidanceUtils.getEnrollmentDueDate(planYearStartDate);
            
        return `Click the Download Current Enrollments button in this panel and update the enrollment spreadsheet with the information of participants who wish to elect. Once completed, click Upload Your Enrollments to load your updated spreadsheet.`
                + `<br>To ensure timely delivery of cards to any new participants or participants with cards due to expire, please submit your enrollments by ${dateString}.`;
    }

    async function getActions(guidanceItem) {
        var actions = [
            {
                text: 'Download Current Enrollments',
                loadNextGuidance: false,
                click: (component, guidanceItem) => {romeApi.download(`employer/${guidanceItem.employerId}/enrollment/${guidanceItem.actionItemId}/download`);}
            },
            { 
                fileSelector: true,
                text: `Upload Your Enrollments`,
                loadNextGuidance: false,
                fileSelectedText: 'Validating enrollment data',
                onFileSelected: async (component, guidanceItem, file) => {
                    if(!file) return;
                    
                    let success = await uploadEnrollmentsService.onSpreadsheetSelect(file, guidanceItem.employerId, guidanceItem.actionItemId);
    
                    if(success === true) {
                        await uploadEnrollmentsService.validateActionItem( guidanceItem.employerId, guidanceItem.actionItemId);
                        await component.refresh();
    
                    }  else {
                        component.clearFileSelectedValues();
                    } 
                },
                click: async (component, guidanceItem) => {
                    component.triggerUploader();
                },
            },
        ];

        var thresholdMet = await romeApi.get(`employer/${guidanceItem.employerId}/enrollment/threshold-met/${guidanceItem.actionItemId}`);
        if(thresholdMet == true) {
            actions.push(
                {
                    text: "Finish Enrollments",
                    click: async (component, guidanceItem) =>  {
                        let result = await validateEnrollments(guidanceItem.employerId, guidanceItem.actionItemId);

                        var enrollmentsComplete = await modalService.show("EnrollmentConfirmation", EnrollmentConfirmation, { 
                            lines: result.warnings,
                            errorStyle: true,
                        });

                        if(enrollmentsComplete == true) {
                            await romeApi.post(`employer/${guidanceItem.employerId}/bypass/${guidanceItem.actionItemId}`);
                            await component.refresh();
                        }
                    },})
        }
        return actions;
    }

    async function validateEnrollments(employerId, actionItemId) {
        return await romeApi.get(`employer/${employerId}/enrollment/data/${actionItemId}`);
    }


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-upload-spreadsheet.js